import { Button, Divider } from "@material-ui/core";
import React, { useState } from "react";

const BookSettings = () => {
  const [books] = useState([
    "43SPORT", "5STARWAGERZ", "ABLEBET", "ACTION514", "ANARCHY",
    "BANDERA123", "BESTBETSPORT", "BETGALLOROJO", "BETGRANDE",
    "BETLONESTAR", "BETMYPOOLS.COM", "BETNOLA", "BETSITE365"
  ]);

  const [permissions, setPermissions] = useState([
    { name: "All Players Get Canadian Line", checked: true },
    { name: "Buy Points In Periods", checked: false },
    { name: "Display Both Teams On Totals", checked: false },
    { name: "MLB Halves Use Listed Pitchers", checked: false },
    { name: "Use True Odds as Default Formula", checked: true },
    { name: "Use Real Round", checked: true }
  ]);

  const [selectedBook, setSelectedBook] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedOption, setSelectedOption] = useState("0");

  const handleEdit = () => setIsEditing(true);
  const handleSave = () => setIsEditing(false);
  const handleCheckboxChange = (index) => {
    if (!isEditing) return;
    setPermissions((prev) => {
      const updated = [...prev];
      updated[index].checked = !updated[index].checked;
      return updated;
    });
  };

  return (
    <div className="MuiTable-root2">
      <h2>Book Client Settings</h2>
      <Divider className="mt-4 mb-4"></Divider>
        <div className="p-4 border rounded-lg bg-gray-50 w-full ">
            {/* Buttons */}
            <div className="mb-4 flex gap-2">
                <Button
                size="small"
                variant="contained"
                color="primary"
                disabled={!isEditing} 
                onClick={handleSave}
                >
                Save
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    disabled={isEditing} 
                    onClick={handleEdit}
                    className="ml-2"
                >
                    Edit
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    className="ml-2"
                    
                >
                    Changes
                </Button>
            
                {/* <button className="px-3 py-1 bg-gray-400 text-white rounded" disabled>
                Undo
                </button> */}
            </div>
            <div className="flex gap-2">
                {/* Books List */}
                <div className="w-1/2 border bg-white overflow-y-auto h-72 rounded-md">
                {books.map((book) => (
                    <div
                    key={book}
                    className={`p-2 pl-4 cursor-pointer border-b border-gray-200 font-semibold text-xs ${selectedBook === book ? "bg-blue-200" : ""}`}
                    onClick={() => setSelectedBook(book)}
                    >
                    {book}
                    </div>
                ))}
                </div>
                
                {/* Permissions List */}
                <div className="w-1/2 flex flex-col gap-1">
                    <div className=" bg-white  border h-48 flex flex-col gap-1 p-3">
                    {permissions.map((perm, index) => (
                        <div key={index} className="flex items-center gap-2 text-xs">
                        <input
                            type="checkbox"
                            checked={perm.checked}
                            disabled={!isEditing}
                            onChange={() => handleCheckboxChange(index)}
                        />
                        <span>{perm.name}</span>
                        </div>
                    ))}
                    </div>
                    <div className="p-2">
                        <span className="text-xs font-semibold ">Check Min/Max wager limits on:</span>
                        <div className="mt-1 ml-2">
                        <div className=" h-[20px] flex items-center gap-2">
                            <input
                            className=""
                            type="radio"
                            id="optionDefault"
                            name="amountOption"
                            value="0"
                            checked={selectedOption === "0"}
                            onChange={(e) => setSelectedOption(e.target.value)}
                            />
                            <label className="form-check-label text-xs" htmlFor="optionDefault">Default</label>
                        </div>
                        <div className=" h-[20px] flex items-center gap-2">
                            <input
                            className=""
                            type="radio"
                            id="optionRisk"
                            name="amountOption"
                            value="1"
                            checked={selectedOption === "1"}
                            onChange={(e) => setSelectedOption(e.target.value)}
                            />
                            <label className="form-check-label text-xs" htmlFor="optionRisk">Risk Amount</label>
                        </div>
                        <div className=" h-[20px] flex items-center gap-2">
                            <input
                            className=""
                            type="radio"
                            id="optionWin"
                            name="amountOption"
                            value="2"
                            checked={selectedOption === "2"}
                            onChange={(e) => setSelectedOption(e.target.value)}
                            />
                            <label className="form-check-label text-xs" htmlFor="optionWin">Win Amount</label>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        
      
        </div>
    </div>
  );
};

export default BookSettings;
